const InvestmentInformationEvents = {
    CONTINUE_FUND_INFORMATION_CLICKED: "fund_information_continue_button_clicked"
};

export default InvestmentInformationEvents;
